import type { TourStep } from "../types";

export const newSuggestionSteps: TourStep[] = [
  {
    title: "Submitting a suggestion",
    description:
      "Two cards: who the suggestion is from and where it belongs, then the idea itself. Fields marked with an asterisk are required.",
  },
  {
    anchor: "new-suggestion-form",
    title: "Describe the improvement",
    description:
      "A specific title and enough description for a committee to judge it. Suggestion Department and Category sit in the card above — they decide who reviews it.",
  },
  {
    anchor: "new-suggestion-attachments",
    title: "Attachments",
    description:
      "Photos, sketches or documents that make the case. JPG, PNG, PDF or DOCX, up to 10 MB each.",
  },
  {
    anchor: "new-suggestion-submit",
    title: "Submit",
    description:
      "Stays disabled until the required fields are valid. On submit the suggestion gets its number and enters the review pipeline; track it from the register.",
  },
];
